module.exports = __webpack_public_path__ + "static/media/wicketRound.d3190960.jpg";